import React from 'react'

const MajorLaptop = props => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.24 15.52H21a2.266 2.266 0 000-.25V5.78A1.75 1.75 0 0019.23 4H4.75A1.75 1.75 0 003 5.78v9.49a1.13 1.13 0 000 .25h-.26a.75.75 0 00-.75.75v2A1.76 1.76 0 003.74 20h16.5A1.76 1.76 0 0022 18.25v-2a.75.75 0 00-.76-.73zM4.5 5.78a.25.25 0 01.25-.25h14.48a.25.25 0 01.25.25v9.49a.25.25 0 01-.25.25H4.75a.25.25 0 01-.25-.25V5.78zM20.25 18.5a.25.25 0 00.25-.25L20.49 17h-5.12a.74.74 0 01-.74.72H9.35a.74.74 0 01-.74-.72H3.49v1.25c0 .138.112.25.25.25h16.51z"
      fill={props.fill || '#fff'}
    />
  </svg>
  )

export default MajorLaptop
